import { createRoot } from 'react-dom/client';

// Import the request utility to initialize it
import './utils/request';

import App from './App';

createRoot(document.getElementById('root')!).render(<App />);
